
const Terms = () => (
  <>
    <main className="pt-32 lg:pt-28 pb-16">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-3xl lg:text-4xl font-heading font-bold text-foreground mb-2">Terms of Use</h1>
        <p className="text-muted-foreground text-sm mb-8">Last updated: April 10, 2026</p>

        <div className="prose prose-neutral max-w-none space-y-6 text-foreground/90 leading-relaxed">
          <section>
            <h2 className="text-xl font-heading font-bold text-foreground mt-8 mb-3">1. Acceptance of Terms</h2>
            <p className="text-muted-foreground">By accessing and using the Kodiak Structures & Exteriors website ("Site"), you agree to be bound by these Terms of Use.</p>
          </section>
          <section>
            <h2 className="text-xl font-heading font-bold text-foreground mt-8 mb-3">2. Use of the Site</h2>
            <p className="text-muted-foreground">You may use this Site for lawful purposes only. You agree not to attempt to gain unauthorized access, use automated scraping tools, or transmit harmful code.</p>
          </section>
          <section>
            <h2 className="text-xl font-heading font-bold text-foreground mt-8 mb-3">3. Intellectual Property</h2>
            <p className="text-muted-foreground">All content on this Site — including text, images, logos, graphics, and design — is the property of Kodiak Structures & Exteriors and is protected by copyright and intellectual property laws.</p>
          </section>
          <section>
            <h2 className="text-xl font-heading font-bold text-foreground mt-8 mb-3">4. Service Descriptions</h2>
            <p className="text-muted-foreground">We make every effort to accurately describe our services. Actual services may vary based on property conditions, location, and other factors discussed during the estimate process.</p>
          </section>
          <section>
            <h2 className="text-xl font-heading font-bold text-foreground mt-8 mb-3">5. Estimates & Pricing</h2>
            <p className="text-muted-foreground">Any pricing information displayed is for general reference only. Final pricing is determined through our estimate process and may vary based on project scope and conditions.</p>
          </section>
          <section>
            <h2 className="text-xl font-heading font-bold text-foreground mt-8 mb-3">6. Limitation of Liability</h2>
            <p className="text-muted-foreground">This Site is provided "as is" without warranties of any kind. Kodiak Structures & Exteriors shall not be liable for any indirect, incidental, or consequential damages arising from your use of the Site.</p>
          </section>
          <section>
            <h2 className="text-xl font-heading font-bold text-foreground mt-8 mb-3">7. Governing Law</h2>
            <p className="text-muted-foreground">These Terms shall be governed by the laws of the State of Minnesota. Any disputes shall be subject to the exclusive jurisdiction of courts in Anoka County, Minnesota.</p>
          </section>
          <section>
            <h2 className="text-xl font-heading font-bold text-foreground mt-8 mb-3">8. Contact Us</h2>
            <p className="text-muted-foreground">If you have questions about these Terms, please contact us at:</p>
            <p className="text-muted-foreground mt-2">
              <strong className="text-foreground">Kodiak Structures & Exteriors</strong><br />
              Phone: (651) 983-1609
            </p>
          </section>
        </div>
      </div>
    </main>
  </>
);

export default Terms;
